import type { Locale } from '../../../../../../../../localization/i18n'

interface Props {
  dateStr: string
  locale: Locale
  timeZone: string
}

export default function formatTime({ dateStr, locale, timeZone }: Props) {
  return new Date(dateStr).toLocaleTimeString(locale, {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
    timeZone,
  })
}
